import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ShopModule } from "../../types/shopModuleTypes";
import { fetchShopModulesThunk } from "../thunk/shopModulesThunk";

export interface ShopModulesState {
  shopModules: ShopModule[];
}

const initialState: ShopModulesState = {
  shopModules: [],
};

export const shopModulesSlice = createSlice({
  name: "shopModules",
  initialState,
  reducers: {
    setShopModules: (state, action: PayloadAction<ShopModule[]>) => {
      state.shopModules = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchShopModulesThunk.fulfilled, (state, action) => {
      state.shopModules = action.payload ?? [];
    });
  },
});

export const { setShopModules } = shopModulesSlice.actions;

export default shopModulesSlice.reducer;
